import { createSlice } from "@reduxjs/toolkit";
import { loginThunk, signUpThunk } from "../thunks/authThunk";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: "",
  },
  reducers: {
    logout: (state, action) => {
      state.user = "";
      // localStorage.removeItem("persist:root");
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.fulfilled, (state, action) => {
        if (action.payload?.data?.user?.role_id == 2) {
          state.user = action.payload?.data;
        }
      })
      .addCase(signUpThunk.fulfilled, (state, action) => {
        state.user = action.payload?.data;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
